export const JITSI_MEET_CONFIG = {
  resolution: 720,
  startAudioBitrate: 32,
  enableLayerSuspension: true,
  disableSimulcast: false,
  constraints: {
    video: {
      height: {
        ideal: 720,
        max: 720,
        min: 240,
      },
      width: {
        ideal: 1280,
        max: 1280,
        min: 320,
      },
      frameRate: {
        ideal: 24,
        max: 24,
        min: 15,
      },
      aspectRatio: 16 / 9,
    },
  },
  videoQuality: {
    preferredCodec: 'VP8',
    maxFullResolutionParticipants: 1,
    maxBitratesVideo: {
      low: 150000, // low bitrate
      standard: 350000, // standard bitrate
      high: 1200000, // high bitrate
      HD: 2000000, // HD bitrate (kept but modest)
    },
  },
};

export const JITSI_OPTIMAL_AUDIO_CONSTRAINTS = {
  autoGainControl: true,
  echoCancellation: true,
  noiseSuppression: true,
  channelCount: 1,
  sampleRate: 48000,
  sampleSize: 16,
};

export const JITSI_OPTIMAL_VIDEO_CONSTRAINTS = {
  aspectRatio: 16 / 9,
  height: {
    ideal: 720,
    max: 720,
    min: 240,
  },
  width: {
    ideal: 1280,
    max: 1280,
    min: 320,
  },
  frameRate: {
    ideal: 24,
    max: 24,
    min: 15,
  },
};

export const JITSI_OPTIMAL_VIDEO_CONSTRAINTS_GROUP = {
  aspectRatio: 16 / 9,
  height: {
    ideal: 480,
    max: 480,
    min: 180,
  },
  width: {
    ideal: 854,
    max: 854,
    min: 320,
  },
  frameRate: {
    ideal: 24,
    max: 24,
    min: 10,
  },
};

export const JITSI_OPTIMAL_BITRATE_CONFIG = {
  startBitrate: 800,
  startAudioBitrate: 32,
  minBitrate: 300,
  maxBitrate: 1800,
  stereo: false, // mono for speech
  opusMaxAverageBitrate: 32000, // ~32 kbps for robust voice
  // If supported in your build, redundancy helps with packet loss:
  // enableOpusRed: true,
};

export const JITSI_OPTIMAL_VIDEO_QUALITY = {
  preferredCodec: 'VP8', // keep consistent with JITSI_MEET_CONFIG.videoQuality
};

export const JITSI_DEFAULT_RESOLUTION = 720;
export const JITSI_DEFAULT_RESOLUTION_GROUP = 480;

// Fast startup: lower initial constraints for quicker camera access
export const JITSI_FAST_START_VIDEO_CONSTRAINTS = {
  aspectRatio: 16 / 9,
  height: {
    ideal: 360,
    max: 480,
    min: 240,
  },
  width: {
    ideal: 640,
    max: 854,
    min: 320,
  },
  frameRate: {
    ideal: 15,
    max: 20,
    min: 10,
  },
};

// Bitrate caps per screen resolution tier used for screen sharing
export const SCREEN_SHARE_BITRATE_BY_TIER = {
  '720p': { low: 200000, standard: 500000, high: 1200000, HD: 1500000 },
  '1080p': { low: 300000, standard: 800000, high: 2500000, HD: 3000000 },
  '2K': { low: 500000, standard: 1200000, high: 4000000, HD: 5000000 },
  '4K': { low: 800000, standard: 2000000, high: 6000000, HD: 8000000 },
};

export const JITSI_VIDEO_QUALITY_UPGRADE_DELAY_MS = 5000;

export const CONFERENCE_LEAVE_REASONS = {
  SWITCH_ROOM: 'switch_room',
  UNRECOVERABLE_ERROR: 'unrecoverable_error',
};

export const DEFAULT_PROFILE_PICTURE =
  'https://wlkostorage.blob.core.windows.net/avatars/generic-avatar.jpg';

export const DEFAULT_ORG_LOGO =
  'https://nexgen-dev-org-files-public.s3.us-east-1.amazonaws.com/org/6bc87e30-7015-4ae1-9ed6-1e7290163ee2/nexgen-logo.png';

export const DEFAULT_ORG_CANVAS =
  'https://nexgen-dev-org-files-public.s3.us-east-1.amazonaws.com/org/6bc87e30-7015-4ae1-9ed6-1e7290163ee2/location-nexgen-1.jpg';
